import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { AuthService } from 'src/services/auth/auth.service';

@Component({
  selector: 'settings-menu',
  standalone: true,
  imports: [MatListModule, MatIconModule, CommonModule],
  templateUrl: './settings-menu.component.html',
  styleUrl: './settings-menu.component.scss',
})
export class SettingsMenuComponent {
  @Output() menuItemClicked: EventEmitter<string> = new EventEmitter<string>();

  constructor(public authService: AuthService) {}
}
